<template>
    <button :type="type" :disabled="isSending">
        <template v-if="isSending">
            <font-awesome-icon icon="spinner" spin v-if="isSending" />
        </template>

        <template v-else>
            <slot>{{ $t('submit') }}</slot>
        </template>
    </button>
</template>

<script>
    export default {
        props: {
            isSending: {
                type: Boolean,
                required: true,
            },

            type: {
                type: String,
                default: 'submit',
            },
        },
    };
</script>
